import React from 'react';
import { Route } from 'react-router-dom';
import CaseList from './List';
import CaseDetail from './Detail';

const routers = [
  <Route key="/detail" path="*/detail" exact component={CaseDetail} />, // 案例详情
  <Route key="/" path="*/" component={CaseList} />, // 案例列表
];

export default routers;
